module.exports = __webpack_public_path__ + "img/idioma.aa27c3d2.png";